import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useCustomerId } from 'features/customers/hooks/useCustomerId'

import { useAddNotification } from 'hooks/useAddNotification'
import { post } from 'utils/http'

export const useResendVerifyEmail = () => {
  const customerId = useCustomerId()
  const addNotification = useAddNotification()
  const queryClient = useQueryClient()

  const resendVerifyEmail = async (userId: any) =>
    post(`/verify/resend/invitation/customers/${customerId}/users/${userId}`)

  return useMutation({
    mutationFn: resendVerifyEmail,
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ['customer', customerId, 'users'] })

      await addNotification('Email has been resent')
    },
  })
}
